import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import './Silder.css'
const Silder = () => {
    const [index, setIndex] = useState(0);
          
    const handleSelect = (selectedIndex, e) => {
      setIndex(selectedIndex);
    };
    return (
               <>
              <Carousel activeIndex={index} onSelect={handleSelect}>
                <Carousel.Item>
                  <img  
                    className="d-block w-100 jpg  "
                    src="https://i.ibb.co/5M9yyJW/motorcycle-with-helmet-1.png"
                    alt="First slide"
                  />
                  <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100 jpg "
                     src="https://i.ibb.co/FYymF21/2016-MV-Agusta-Brutale-1090-Streetbike-in-black-o.png"
                    alt="Second slide"
                  />
          
                  <Carousel.Caption>
                    <h3>Second slide label</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100 jpg "
                    src="https://i.ibb.co/JkPKsj4/2019-bmw-r-1250-gs-everything-we-know.jpg"
                    alt="Third slide"
                  />
          
                  <Carousel.Caption>
                    <h3>Third slide label</h3>
                    <p>
                      Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                    </p>
                  </Carousel.Caption>
                </Carousel.Item>
              </Carousel>
            
              </> 
    )
}

export default Silder;